import type { NavItemProps } from "../components/organisms/nav-bar/nav-item/nav-item";
import { AddIcon, ArchiveIcon, CmsIcon, CompanyIcon, DashboardIcon, EmailIcon, ImageIcon, ItineraryIcon, PlaceIcon, ReportIcon, SettingsIcon, SignOutIcon, SignUpRequestIcon, SpecialOfferIcon, TableIcon, VideoIcon, WarningIcon } from "../components/atoms/icons/mui-icons";
import { MasqueradeIcon } from "../components/atoms/icons/masquerade-icon";


export const NAV_ITEMS: Readonly<NavItemProps[]> = [
	{
		kind: "route",
		path: "/broker/search",
		labelKey: "nav:search",
	},
	{
		kind: "route",
		path: "/broker/proposals",
		labelKey: "nav:proposals",
	},
	{
		kind: "route",
		path: "/history",
		labelKey: "nav:emailHistory",
	},
	{
		kind: "gaff",
		path: "/app/#/fleet",
		labelKey: "nav:fleetManagement",
		permissions: { some: [ "YACHT", "CENTRAL" ] },
	},
	{
		kind: "menu",
		labelKey: "nav:bookings.title",
		items: [
			{
				kind: "gaff",
				labelKey: "nav:bookings.dashboard",
				icon: DashboardIcon,
				path: "/app/#/reservations/dashboard",
			}, {
				kind: "gaff",
				labelKey: "nav:bookings.addReservation",
				icon: AddIcon,
				path: "/app/#/reservations/records/new",
			}, {
				kind: "gaff",
				labelKey: "nav:bookings.historicRecords",
				icon: ArchiveIcon,
				path: "/app/#/reservations/records",
			}, {
				kind: "gaff",
				labelKey: "nav:bookings.emailNotifications",
				icon: EmailIcon,
				path: "/app/#/reservations/emails",
			}, {
				kind: "gaff",
				labelKey: "nav:bookings.settings",
				icon: SettingsIcon,
				path: "/app/#/reservations/settings",
			},
		],
	},
	{
		kind: "menu",
		labelKey: "nav:admin.title",
		permissions: "ADMIN",
		items: [
			{
				kind: "route",
				labelKey: "nav:admin.agenciesAndUsers",
				icon: CompanyIcon,
				path: "/settings/agency-and-users",
			},
			{
				kind: "route",
				labelKey: "nav:admin.csvUpdater",
				icon: TableIcon,
				path: "/admin/csv/viewyacht",
			},
			{
				kind: "route",
				labelKey: "nav:admin.crows",
				icon: ReportIcon,
				path: "/admin/crows",
			},
			{
				kind: "gaff",
				labelKey: "nav:admin.cms",
				icon: CmsIcon,
				path: "/app/#/cms/articles",
			},
			{
				kind: "gaff",
				labelKey: "nav:admin.images",
				icon: ImageIcon,
				path: "/app/#/cms/images",
			},
			{
				kind: "route",
				labelKey: "nav:admin.itineraryLocations",
				icon: PlaceIcon,
				path: "/itinerary-locations",
			},
			{
				kind: "route",
				labelKey: "nav:admin.itineraryTemplates",
				icon: ItineraryIcon,
				path: "/broker/itinerary-templates",
			},
			{
				kind: "gaff",
				labelKey: "nav:admin.reports",
				icon: ReportIcon,
				path: "/app/#/report",
			},
			{
				kind: "route",
				labelKey: "nav:admin.signUpRequests",
				icon: SignUpRequestIcon,
				path: "/admin/sign-up-requests",
			},
			{
				kind: "route",
				labelKey: "nav:admin.videos",
				icon: VideoIcon,
				path: "/admin/videos",
			},
			{
				kind: "route",
				labelKey: "nav:admin.offers",
				icon: SpecialOfferIcon,
				path: "/central/offers",
			},
			{
				kind: "route",
				labelKey: "nav:admin.alerts",
				icon: WarningIcon,
				path: "/admin/alerts",
			},
			{
				kind: "action",
				labelKey: "nav:admin.masquerade",
				icon: MasqueradeIcon,
				action: ({ auth }) => auth.masqueradeController.openDialog(),
			},
		],
	},
	{
		kind: "menu",
		labelKey: "nav:settings.title",
		items: [
			{
				kind: "route",
				labelKey: "nav:settings.settings",
				icon: SettingsIcon,
				path: "/settings",
			},
			{
				kind: "action",
				labelKey: "nav:settings.signOut",
				icon: SignOutIcon,
				action: services => services.auth.signOut(),
			},
		],
	},
];
